import { TableReport } from "../reports/TableReport";
import React from "react";
import { Link } from "react-router-dom";
import { BadgeDomain } from "../../_components/Abstractions/BadgeDomain";
import { OrderStatusBadge } from "../../_components/OrderViews/Components/OrderStatusBadge";
import { Accordion, AccordionItem } from "react-bootstrap";
import { WasteFormType } from "../../domain/WasteFormType";

export const OrderWasteReportGroup = ({ result, skipStatus, fullReport }) => {
  if (!result || result.loading || result.error) {
    return;
  }

  const { wasteCodeSummary, wasteKindSummary, detailedSummary } = result;
  if(!detailedSummary) {
      return;
  }


  return (
    <>
      <Accordion defaultActiveKey={[0, 1]} alwaysOpen>
        <AccordionItem eventKey={0} defaultValue={0}>
          <Accordion.Header as="h5">Zestawienie z podziałem na kody</Accordion.Header>
          <Accordion.Body>
            <TableReport>
              <thead>
              <tr>
                <th style={{ width: "40%" }}>Sort</th>
                <th style={{ width: "20%" }}>Masa [MG]</th>
                <th style={{ width: "20%" }}>Ceny [zł/t]</th>
                <th style={{ width: "20%" }}>Wartość netto [zł]</th>
              </tr>
              </thead>
              <tbody>
              {wasteCodeSummary?.map((x, i) => (
                <tr key={i}>
                  <td><BadgeDomain>{x.description}</BadgeDomain></td>
                  <td>{x.wasteMass?.toFixed(4)}</td>
                  <td>{x.prices.map(x => x?.toFixed(2)).join(" / ") }</td>
                  <td>{x.netAmount?.toFixed(2) ?? "-"}</td>
                </tr>
              ))}
              </tbody>
            </TableReport>
          </Accordion.Body>
        </AccordionItem>
        <AccordionItem eventKey={1}>
          <Accordion.Header as="h5">Zestawienie z podziałem na gatunki</Accordion.Header>
          <Accordion.Body>
            <TableReport>
              <thead>
              <tr>
                <th style={{ width: "40%" }}>Sort</th>
                <th style={{ width: "20%" }}>Masa [MG]</th>
                <th style={{ width: "20%" }}>Ceny [zł/t]</th>
                <th style={{ width: "20%" }}>Wartość netto [zł]</th>
              </tr>
              </thead>
              <tbody>
              {wasteKindSummary?.map((x, i) => (
                <tr key={i}>
                  <td><BadgeDomain>{x.code}</BadgeDomain> {x.description} {x.wasteFormType && `- ${WasteFormType[x.wasteFormType]}`}</td>
                  <td>{x.wasteMass?.toFixed(4)}</td>
                  <td>{x.prices.map(x => x?.toFixed(2)).join(" / ")}</td>
                  <td>{x.netAmount?.toFixed(2) ?? "-"}</td>
                </tr>
              ))}
              </tbody>
            </TableReport>
          </Accordion.Body>
        </AccordionItem>
        <AccordionItem eventKey={2}>
          <Accordion.Header as="h5">Zestawienie z podziałem na zlecenia</Accordion.Header>
          <Accordion.Body>
            <TableReport>
              <thead>
              <tr>
                <th style={{ width: "8%" }}>Nr. zlecenia</th>
                <th style={{ width: "10%" }}>Klient</th>
                <th style={{ width: "15%" }}>Adres</th>
                <th style={{ width: "10%" }}>Pośrednik</th>
                <th style={{ width: "5%" }}>Status</th>
                <th style={{ width: "8%" }}>Data załadunku</th>
                <th style={{ width: "15%" }}>Towar</th>
                {/*<th style={{ width: "10%" }}>Ilość [T]</th>*/}
                {/*<th style={{ width: "10%" }}>Cena</th>*/}
              </tr>
              </thead>
              <tbody>
              {detailedSummary?.map((entry, index) => (
                <OrderWasteReportEntry key={index} entry={entry} skipStatus={skipStatus} fullReport={fullReport}/>
              ))}
              </tbody>
            </TableReport>
          </Accordion.Body>
        </AccordionItem>
      </Accordion>
    </>
  );
};

export const OrderWasteReportEntry = ({ entry }) => (
  <tr>
    <td><Link target="_blank" to={`/orders/${entry.id}`}>{entry.orderNumber}</Link></td>
    <td>{entry.contractorName}13</td>
    <td>{entry.addressName}</td>
    <td>{entry.intermediaryName}</td>
    <th><OrderStatusBadge status={entry.status}/></th>
    <td>{entry.realLoadingDate}</td>
    <td>{entry.wastesDetails.map((x, i) => (
      <div key={i}>
        <BadgeDomain>{x.code}</BadgeDomain> {x.description} {x.wasteFormType && `- ${WasteFormType[x.wasteFormType]}`}
        {" : " }{x.wasteMass.toFixed(4)} - {x.price ?? "-"} zł
      </div>
    ))}</td>
  </tr>
);